import { render } from "./SendSuccess.vue?vue&type=template&id=45648240&scoped=true"
import script from "./SendSuccess.vue?vue&type=script&lang=js"
export * from "./SendSuccess.vue?vue&type=script&lang=js"

import "./SendSuccess.vue?vue&type=style&index=0&id=45648240&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45648240"]])

export default __exports__